import { createFileRoute } from "@tanstack/react-router";
import { CopyWishlistRoute } from "./-wishlistDeepLink";

export const Route = createFileRoute("/copyWishlist")({
  component: CopyWishlistRoute,
});
